module.exports = __webpack_public_path__ + "res/24-img_back_rtl.499cc5f9218611306a9dff9b0f03d9ab.png";